import {AuthRepository} from '@domain/model/Auth/AuthRepository';
import {AuthLoginFaceBook} from '@domain/model/Auth/AuthLoginFaceBook';

export const RegisterWithFaceBook = (repo: AuthRepository) => (params: AuthLoginFaceBook) =>
  repo.registerWithFaceBook(params);
